import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { isLoading, load, createParams } from '../reducers/fastResults';
import { has } from '../../../utils/features';

import HorseRacingFastRacecardsList from '../components/HorseRacingFastRacecardsList';
import { sendFeedReceivedTimeTracking } from 'modules/Common/actions/trackingEvents';
import { unSubscribeRaceUpdates, connectToRaceUpdates, subscribeToRaceUpdates } from '../actions/raceUpdate';

const POLLING_INTERVAL_MILLIS = 5000;
const REFRESH_INTERVAL_MILLIS = has("push-fast-results") ? 60000 : POLLING_INTERVAL_MILLIS;

const dispatch = (params) => load(createParams(params));

@standardAsyncConnect([
  {
    dispatch,
    preventResolve: ({state}) => isLoading(state),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: state => ({
      fastResults: state.horseRacing.fastResults,
      pollFallbackEnabled: state.horseRacing.raceUpdate.pollFallbackEnabled,
      subscribedTopics: state.horseRacing.raceUpdate.subscribedTopics
    })
  }
])

@catchLifeCycleErrors
export default class HorseRacingFastRacecards extends Component {

  static propTypes = {
    fastResults: PropTypes.shape({
      fastResults: PropTypes.arrayOf(PropTypes.shape({
        race_reference: PropTypes.shape({
          id: PropTypes.number.isRequired
        }).isRequired
      })).isRequired
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string
    }),
    dispatch: PropTypes.func.isRequired,
    pollFallbackEnabled: PropTypes.bool,
    subscribedTopics: PropTypes.arrayOf(PropTypes.string)
  };

  hasCountryFilterChanged(newFilters) {
    const current = this.state.countryGroups || [];
    const newGroups = newFilters.filter( function(n) { return !this.has(n) }, new Set(current) );
    const oldGroups = current.filter( function(n) { return !this.has(n) }, new Set(newFilters) );

    return newGroups.length > 0 || oldGroups.length > 0;
  }

  getCountryGroups(location) {
    location = location || this.props.location;
    const params = createParams(location);
    if (!params.countryGroups) {
      return [];
    }

    return params.countryGroups.split(',');
  }

  componentWillMount() {
    const cg = this.getCountryGroups();
    this.setState({countryGroups: cg});
  }

  componentDidMount() {
    if (has("push-fast-results")) {
      this.props.dispatch(connectToRaceUpdates(this.state.countryGroups));
    }
  }

  componentWillReceiveProps(nextProps) {
    const cg = this.getCountryGroups(nextProps.location);
    const filterChanged = this.hasCountryFilterChanged(cg);

    if (!filterChanged && nextProps && nextProps.fastResults.fastResults) {

      const { metric, label, times } = timedFastResultsTracking(
        nextProps.fastResults.fastResults,
        this.props.fastResults.fastResults,
        this.isSubscribedToTopics()
      )

      this.props.dispatch(sendFeedReceivedTimeTracking(metric, label, times))
    }

    if (filterChanged && has("push-fast-results")) {
      this.props.dispatch(subscribeToRaceUpdates(cg));
      this.setState({countryGroups: cg});
    }

    if (this.fallbackTriggered(nextProps.pollFallbackEnabled)) {
      this.activeTimeouts.push(this.timeoutCallback(dispatch, POLLING_INTERVAL_MILLIS, this.activeTimeouts.length));
    }
  }

  isSubscribedToTopics() {
    return this.props.subscribedTopics && this.props.subscribedTopics.length > 0;
  }

  fallbackTriggered(nextFallbackEnabledState) {
    return nextFallbackEnabledState && !this.props.pollFallbackEnabled;
  }

  componentWillUnmount() {
    this.props.dispatch(unSubscribeRaceUpdates());
  }

  render() {
    return (
      <HorseRacingFastRacecardsList fastResults={this.props.fastResults}/>
    );
  }
}

function timedFastResultsTracking(newFastResults, prevFastResults, isUsingPush) {

  const getRaceFeedTimes = fastResults => fastResults
    .reduce( (times, result) => {
      if (result.feed_received && result.race_reference.id) {
        const momentTime = moment(result.feed_received)
        if (momentTime.isValid()) {
          times[result.race_reference.id] = momentTime.valueOf()
        }
      }
      return times
    }, {})

const prevFastResultTimes = getRaceFeedTimes(prevFastResults)
const newFastResultTimes = getRaceFeedTimes(newFastResults)

//map new times to old & return any changed times
const times = Object.keys(newFastResultTimes)
  .map(raceId => {
    if (newFastResultTimes[raceId] > 0 &&
        newFastResultTimes.hasOwnProperty(raceId) &&
        prevFastResultTimes[raceId] !== newFastResultTimes[raceId]
      ) {
        return Date.now() - newFastResultTimes[raceId]
    }
    return 0
  })
  .filter(time => time > 0 && time < 1800000)

  return {
    metric: `timing.feeds.horse-racing.fast-results-received-to-display${isUsingPush ? ".websockets" : ""}`,
    label:  `Horse Racing Fast Results Feed Time${isUsingPush ? " Websocket Connected": ""}`,
    times
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingFastResults.js